import { createGlobalStyle } from 'styled-components'
import { darkTheme, lightTheme } from './themes'

export const theme = {
  colors: {
    primary: '#fbfbfb',
    secondary: {
      main: '#027A00',
      dark: '#013B00',
    },
    error: '#c53030',
    white: {
      main: '#fff',
      secondary: '#f6f6f6',
    },
    black: {
      main: '#000',
      secondary: '#111',
    },
    background: {
      main: '#fbfbfb',
      secondary: '#ddd',
    },
  },
}

interface GlobalTheme {
  theme: typeof darkTheme & typeof lightTheme
}

export const GlobalStyle = createGlobalStyle<GlobalTheme>`
*,
*::before,
*::after {
  box-sizing: border-box;
  transition: color 0.3s;
  transition: background 0.3s;
}
html,
body {
  padding: 0;
  margin: 0;
  font-family: Montserrat, sans-serif;
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  -webkit-font-smoothing: antialiased;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};
  overflow-x: hidden;
}
a {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition-duration: 0.5s;
  :hover {
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
  }
}
button {
  cursor: pointer;
  font-family: Montserrat, sans-serif;
}
* {
  box-sizing: border-box;
}
input, textarea, select {
    outline: 0;
    font-family: 'Montserrat';
}
textarea:focus, input:focus, select:focus {
    box-shadow: 0 0 0 0;
    border: 0 none;
    outline: 0;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background-color: ${({ theme }) => `rgb(${theme.background.high})`};
}
::-webkit-scrollbar-thumb {
  background-color: ${({ theme }) => `rgba(${theme.grayscale.neutral}, 0.7)`};

  border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #333;
}

.loading-block {
  background: ${({ theme }) =>
    theme.isDark
      ? 'linear-gradient(110deg, #161616 8%, #242424 18%, #161616 33%)'
      : 'linear-gradient(110deg, #e2e2e2 8%, #f5f5f5 18%, #e2e2e2 33%)'};
  border-radius: 5px;
  background-size: 200% 100%;
  animation: 1.5s loading-shine linear infinite;
}

@keyframes loading-shine {
  to {
    background-position-x: -200%;
  }
}
`
